"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidWhitelistNft = exports.singleTokenInfoPromise = exports.getTokenMetadataByMintAddress = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const axios_1 = __importDefault(require("axios"));
const crc32 = __importStar(require("crc-32"));
const error_1 = require("../error");
const promiseUtils_1 = require("../utils/promiseUtils");
const parseData_1 = require("./parseData");
const constants_1 = require("../../factory/constants");
const getTokenMetadataByMintAddress = async function (mintAddress, connection) {
    var _a;
    const [newEditionMetadata] = await anchor_1.web3.PublicKey.findProgramAddress([Buffer.from('metadata'), constants_1.TOKEN_METADATA_PROGRAM_ID.toBuffer(), new anchor_1.web3.PublicKey(mintAddress).toBuffer()], constants_1.TOKEN_METADATA_PROGRAM_ID);
    const newEditionMetadataAccountInfo = await (0, promiseUtils_1.safeAwait)(connection.getAccountInfo(newEditionMetadata));
    if (newEditionMetadataAccountInfo.error || !newEditionMetadataAccountInfo.result) {
        throw new error_1.CandyShopError(error_1.CandyShopErrorType.InvalidNFTMetadata);
    }
    const metadata = (0, parseData_1.parseMetadata)(newEditionMetadataAccountInfo.result.data).data;
    return {
        // @ts-ignore
        creators: (_a = metadata.creators) === null || _a === void 0 ? void 0 : _a.map((creator) => ({
            address: new anchor_1.web3.PublicKey(creator.address).toString(),
            verified: creator.verified,
            share: creator.share
        })),
        symbol: metadata.symbol,
        metadataAddress: newEditionMetadata.toString(),
        sellerFeeBasisPoints: metadata.sellerFeeBasisPoints
    };
};
exports.getTokenMetadataByMintAddress = getTokenMetadataByMintAddress;
const singleTokenInfoPromise = async (param) => {
    const connection = param.connection;
    const tokenAccountAddress = param.tokenAccountAddress;
    const identifiers = param.identifiers;
    const tokenAccount = await (0, spl_token_1.getAccount)(connection, new anchor_1.web3.PublicKey(tokenAccountAddress));
    const tokenInfo = await getNFTMetadataAccountInfo(connection, tokenAccount);
    if (!tokenInfo) {
        console.log(`singleTokenInfoPromise: tokenAccount ${tokenAccountAddress} does not have metadata`);
        return null;
    }
    if (!(0, exports.isValidWhitelistNft)(identifiers, tokenInfo)) {
        return null;
    }
    const nftMetaDataInfo = await fetchMetadataInfoByUri(tokenInfo.data.uri);
    if (!nftMetaDataInfo) {
        return null;
    }
    const tokenEdition = await getNFTEditionInfo(connection, tokenAccount);
    const singleTokenInfo = {
        tokenAccountAddress: tokenAccountAddress,
        metadata: tokenInfo,
        edition: tokenEdition,
        tokenMintAddress: tokenAccount.mint.toString(),
        nftImage: nftMetaDataInfo.nftImage,
        nftAnimation: nftMetaDataInfo.nftAnimation,
        nftDescription: nftMetaDataInfo.nftDescription
    };
    return singleTokenInfo;
};
exports.singleTokenInfoPromise = singleTokenInfoPromise;
const getNFTMetadataAccountInfo = async (connection, tokenAccount) => {
    const [nftMetadataPublicKey] = await anchor_1.web3.PublicKey.findProgramAddress([Buffer.from('metadata'), constants_1.TOKEN_METADATA_PROGRAM_ID.toBuffer(), tokenAccount.mint.toBuffer()], constants_1.TOKEN_METADATA_PROGRAM_ID);
    const nftMetadataAccountInfo = await (0, promiseUtils_1.safeAwait)(connection.getAccountInfo(nftMetadataPublicKey));
    if (nftMetadataAccountInfo.error) {
        throw new error_1.CandyShopError(error_1.CandyShopErrorType.FailToFetchOnchainAccount);
    }
    const tokenInfo = nftMetadataAccountInfo.result ? (0, parseData_1.parseMetadata)(nftMetadataAccountInfo.result.data) : undefined;
    return tokenInfo;
};
const getNFTEditionInfo = async (connection, tokenAccount) => {
    const [nftEditionPublicKey] = await anchor_1.web3.PublicKey.findProgramAddress([
        Buffer.from('metadata'),
        constants_1.TOKEN_METADATA_PROGRAM_ID.toBuffer(),
        tokenAccount.mint.toBuffer(),
        Buffer.from('edition')
    ], constants_1.TOKEN_METADATA_PROGRAM_ID);
    const nftEditionAccountInfo = await (0, promiseUtils_1.safeAwait)(connection.getAccountInfo(nftEditionPublicKey));
    if (nftEditionAccountInfo.error) {
        throw new error_1.CandyShopError(error_1.CandyShopErrorType.FailToFetchOnchainAccount);
    }
    const editionInfo = nftEditionAccountInfo.result
        ? (0, parseData_1.parseEdition)(nftEditionAccountInfo.result.data).edition.toString()
        : undefined;
    return editionInfo;
};
const fetchMetadataInfoByUri = async (nftUri) => {
    const res = await (0, promiseUtils_1.safeAwait)(axios_1.default.get(nftUri));
    if (res.error) {
        console.log('singleTokenInfoPromise: Failed to fetch uri data, error=', res.error);
        return null;
    }
    const nftUriData = res.result.data;
    const nftImage = nftUriData.image;
    const nftAnimation = nftUriData.animation_url;
    const nftDescription = nftUriData.description;
    const nftMetaDataInfo = {
        nftImage: nftImage,
        nftAnimation: nftAnimation,
        nftDescription: nftDescription
    };
    return nftMetaDataInfo;
};
const isValidWhitelistNft = (identifiers, tokenInfo) => {
    var _a;
    if (identifiers === undefined)
        return true;
    const creators = (_a = tokenInfo.data.creators) === null || _a === void 0 ? void 0 : _a.map((creator) => ({
        address: new anchor_1.web3.PublicKey(creator.address).toString(),
        verified: creator.verified,
        share: creator.share
    }));
    const symbol = tokenInfo.data.symbol;
    const str = symbol + JSON.stringify(creators);
    const identifier = crc32.str(str).toString();
    return identifiers.includes(identifier);
};
exports.isValidWhitelistNft = isValidWhitelistNft;
